export const getGraphqlGatewayUrl = () => {
  let graphqlUrl = 'https://api.audiusa.com/graphql';

  if (typeof window !== 'undefined') {
    const { search } = window.location;
    const paramsEnv = new URLSearchParams(search).get('environment');
    // running locally or on dev environment
    if (paramsEnv === 'development' || process.env.NODE_ENV === 'development') {
      graphqlUrl = 'https://qa-api.audiusa.com/graphql';
    }
  }
  return graphqlUrl;
};
